// extracted by mini-css-extract-plugin
export var button = "product-card-module--button--7fi6G";
export var container = "product-card-module--container--Vm4YP";
export var img = "product-card-module--img--+os-M";
export var imgContainer = "product-card-module--img-container--kPG8O";
export var padlock = "product-card-module--padlock--hbU+I";
export var textFirst = "product-card-module--text-first--uszOA";
export var textSecond = "product-card-module--text-second--76wU5";